import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

 useEffect(() => {
    const delay = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 400); // matches framer-motion exit animation

    return () => clearTimeout(delay);
  }, [pathname]);

  return null;
}